import React from 'react';
import { IIconProps } from './utils';

export const Close = ({ fill = 'currentColor' } : IIconProps) => (
  <svg fill={fill} height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 8L12 12L8 16M8 8L12 12L16 16"
      stroke="#777770"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);
